import React, { Component } from 'react';
import ErrorBoundary from '../../../ErrorBoundary';

class DynamicComponent extends Component {
  constructor(props) {
    super(props);
    this.state = { module: null };
  }

  componentDidMount() {
    const { path } = this.props;
    import(
      /* webpackChunkName: "content" */
      /* webpackMode: "lazy" */

      // eslint-disable-next-line comma-dangle
      `${path}`
    ).then((module) => {
      this.setState({ module: module.default });
    });
  }

  render() {
    const { module: WrappedComponent } = this.state;
    return (
      <React.Fragment>
        {this.state.module && (
          <ErrorBoundary location="campaign" errorComponent={null}>
            <WrappedComponent
              url={this.props.url}
              element={this.props.element}
              products={this.props.products}
              isBootroom={this.props.isBootroom}
              loaded={this.props.loaded}
              campaignType={this.props.campaignType}
              order={this.props.order}
              version={this.props.version}
            />
          </ErrorBoundary>
        )}
      </React.Fragment>
    );
  }
}

export default DynamicComponent;
